<template>
  <assign-personal-panel
    ref="panel"
    :config="tabConfig"
    :users-loading="usersLoading"
  />
</template>

<script>
import AssignPersonalPanel from '../AssignPersonalPanel.vue'

const tabConfig = {
  endpoint: '/iso/certificate-managers',
  memberPlural: 'managers',
  addTitle: 'Add certificate manager',
  addHint: 'Select a user, then add them as a certificate manager',
  listTitle: 'Certificate managers list',
  emptyTitle: 'No certificate managers yet',
  emptySearchTitle: 'No matching managers',
  emptyHint: 'Add your first certificate manager above.',
  removeButtonTitle: 'Remove manager',
  loadError: 'Failed to load certificate managers',
  addError: 'Failed to add certificate manager',
  addSuccess: 'Certificate manager added successfully',
  removeTitle: 'Remove this certificate manager?',
  removeSuccess: 'Certificate manager removed',
  removeError: 'Failed to remove certificate manager',
}

export default {
  name: 'CertificateManagersTab',
  components: {
    AssignPersonalPanel,
  },
  props: {
    usersLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabConfig,
    }
  },
  methods: {
    fetchMembers() {
      return this.$refs.panel?.fetchMembers()
    },
  },
}
</script>
